import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { UserService } from '../services/user';

@Injectable({
  providedIn: 'root'
})
export class AccessGuard implements CanActivate {

  constructor(private _userService: UserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const requiredAccess = route.data['accessPage'];
    const adminOnly = route.data['adminOnly'] === true;
    const deniedTypes = (route.data['deniedTypes'] ?? []).map((type: string | number) => String(type));

    return this._userService.getAccountType().pipe(
      map((data: any) => {
        const accountType = String(data['type'] ?? data['user_type'] ?? '').trim();
        const userType = String(data['user_type'] ?? '').trim().toLowerCase();
        const accessPages = data['access_pages'] ?? [];

        if (deniedTypes.includes(accountType)) {
          console.warn('role blocked from page', accountType);
          return this.router.createUrlTree(['/no-data']);
        }

        if (adminOnly) {
          if (accountType === '1' || userType === 'admin') {
            return true;
          }

          console.warn('admin only page');
          return this.router.createUrlTree(['/no-data']);
        }

        if (!requiredAccess) {
          return true;
        }

        if (Array.isArray(accessPages) && accessPages.includes(requiredAccess)) {
          console.log('you have access to page', requiredAccess);
          return true;
        }

        console.warn('no access to page', requiredAccess);
        return this.router.createUrlTree(['/no-data']);
      }),
      catchError((error) => {
        console.error('Guard error:', error);
        return of(this.router.createUrlTree(['/Login']));
      })
    );
  }
}
